import RoundedCheckbox from "./RoundedCheckbox";
import {useRouter} from "next/router";
import localized from "../locale/locales";

export default function CookieGroup({disabled, title, list, body, name, ...rest}) {
    const {locale} = useRouter();
    const lang = localized[locale];

    return (
        <label className={`flex gap-4 shadow-xl rounded-lg p-8 ${disabled ? 'text-gray-400' : 'text-black'}`}
               htmlFor={name}>
            <div>
                <RoundedCheckbox disabled={disabled} name={name} {...rest}/>
            </div>
            <div className="flex-1 flex flex-col gap-4">
                <header>
                    <h2 className="text-lg">{title(lang)}</h2>
                </header>
                {list(lang).length > 0 && (
                    <ul className="list-inside text-sm leading-7">
                        {list(lang).map((item, key) => {
                            return (
                                <li key={`CookieGroupItem: ${key}`}>{item}</li>
                            )
                        })}
                    </ul>
                )}
                {body && (
                    <p className="text-sm leading-relaxed">{body(lang)}</p>
                )}
            </div>
        </label>
    )
}
